class AudioBuffer
{
	url = null;
	buffer = null;
	audioNode = null;
	isPlaying = false;
	autoPlay = false;

	constructor( url, autoPlay )
	{
		this.url = url;
		this.autoPlay = autoPlay;
	}

	play( loop = false )
	{
		if ( AudioManager.audioContext.state == "suspended" ) return;
		if ( window.document.hidden ) return;
		if ( !AudioManager.audioBuffers[this.url] ) return;
		if ( AudioManager.isMute ) return;

		if ( this.isPlaying ) return;

		//console.log( "Play", this.url, this.autoPlay );
		this.audioNode = AudioManager.audioContext.createBufferSource();
		this.audioNode.buffer = AudioManager.audioBuffers[this.url];

		this.audioNode.loop = loop;
		this.audioNode.connect( AudioManager.audioContext.destination );

		this.audioNode.start();
		this.isPlaying = true;

		this.audioNode.onended = () =>
		{
			this.stop();
		};
	}

	stop()
	{
		if ( this.audioNode )
		{
			this.audioNode.stop();
			this.audioNode.buffer = null;
			this.audioNode.disconnect( 0 );
			this.audioNode = null;
		}
		this.isPlaying = false;
	}

	playing()
	{
		return this.isPlaying;
	}

	unload()
	{
		this.stop();
		//AudioManager.audioBuffers[this.url] = null;
	}
}

export default class AudioManager
{
	static audioContext = null;
	static audioBuffers = {};
	static isMute = false;

	static init()
	{

		try
		{
			const AudioContext = window.AudioContext || window.webkitAudioContext;
			AudioManager.audioContext = new AudioContext();

			window.addEventListener( "click", () =>
			{
				//console.log( "Sound, click", AudioManager.audioContext.state );
				if ( AudioManager.audioContext && AudioManager.audioContext.state == "suspended" ) AudioManager.audioContext.resume();
			} );
		}
		catch ( error )
		{
			console.log( "Web Audio API is not supported", error );
		}
	}

	static load( url, autoPlay = false )
	{
		if ( !AudioManager.audioContext ) return null;

		//console.log( "Audio Load", url );
		let audio = new AudioBuffer( url, autoPlay );
		if ( !AudioManager.audioBuffers[url] )
		{
			let request = new XMLHttpRequest();
			request.open( 'GET', url, true );
			request.responseType = 'arraybuffer';

			// Decode asynchronously
			request.onload = function ()
			{
				//console.log( "Audio onLoad", url );
				AudioManager.audioContext.decodeAudioData( request.response, function ( buffer )
				{
					AudioManager.audioBuffers[url] = buffer;
					if ( autoPlay )
					{
						//console.log( "AutoPlay", url );
						audio.play();
					}
				}, ( err ) =>
				{
					console.error( err );
				} );
			};
			request.send();
		}

		return audio;
	}

	static mute( isMute )
	{
		AudioManager.isMute = isMute;
	}
}